import React, { useState, useEffect, useRef } from "react";
import { Table, Col, Breadcrumb, Button, Space, Row, Spin } from "antd";
import { Link, useParams } from "react-router-dom";
import { DownloadOutlined } from "@ant-design/icons";
import plogo from "../../image/plogo.png";
import { getRequest } from "../../axios";
import PropTypes from "prop-types";
import ButtonField from "../../common/htmlComponents/ButtonField";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import logo from "../../image/smartbuyerLogo.png";
import newLogo from "../../image/PROCEM3.svg";

const Commercialinvoicepdf = () => {
  const [orderData, setOrderData] = useState(null);

  const { id } = useParams();
  
  const buttonRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const pdfContainerRef = useRef(null);

  const numberToWords = (num) => {
    if (num === undefined || num === null || isNaN(num))
      return "Zero Rupees Only";
  
    const ones = [
      "",
      "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
      "Sixteen", "Seventeen", "Eighteen", "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];
  
    const convertTwoDigits = (n) => {
      if (n < 20) return ones[n];
      return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    };
  
    const convertThreeDigits = (n) => {
      let word = "";
      if (Math.floor(n / 100) > 0) {
        word += ones[Math.floor(n / 100)] + " Hundred ";
      }
      if (n % 100 > 0) {
        word += convertTwoDigits(n % 100);
      }
      return word.trim();
    };
  
    const convertIndianNumber = (n) => {
      let word = "";
  
      const crore = Math.floor(n / 10000000);
      n %= 10000000;
      const lakh = Math.floor(n / 100000);
      n %= 100000;
      const thousand = Math.floor(n / 1000);
      n %= 1000;
      const hundred = n;
  
      if (crore > 0) word += convertTwoDigits(crore) + " Crore ";
      if (lakh > 0) word += convertTwoDigits(lakh) + " Lakh ";
      if (thousand > 0) word += convertTwoDigits(thousand) + " Thousand ";
      if (hundred > 0) word += convertThreeDigits(hundred);
  
      return word.trim();
    };
  
    const integerPart = Math.floor(num);
    const decimalPart = Math.round((num * 100) % 100); // FIXED HERE
  
    let result = integerPart === 0 ? "Zero Rupees" : convertIndianNumber(integerPart) + " Rupees";
    if (decimalPart > 0) {
      result += " and " + convertTwoDigits(decimalPart) + " Paise";
    }
  
    return result.replace(/\s+/g, ' ').trim() + " Only";
  };
  
  

  useEffect(() => {
    const getPoOrder = async () => {
      try {
        if (!id) {
          return;
        }

        const response = await getRequest(
          `commercial-invoice/${id}/download-commercial-invoice/`
        );

        if (response?.data?.data) {
          console.log("Setting Order Data:", response.data.data);
          setOrderData(response.data.data);
        } else {
          console.error("Unexpected API response structure", response);
        }
      } catch (error) {
        console.error("Error fetching invoice:", error);
      }
    };

    getPoOrder();
  }, [id]);

  // useEffect(() => {
  //   const staticData = {
  //     success: true,
  //     data: {
  //       from: {
  //         name: "IKSHANA AUTOMATION PRIVATE LIMITED",
  //         address: "Ganesh, Glory, Jagatpur, Gujarat, Ahmedabad, 380006",
  //         email: "support@ikshanaautomation.com",
  //         phone: "+91 9714174440",
  //         gst_no: "24AAHCI9193A1ZL",
  //       },
  //       to: {
  //         name: "milan",
  //         address: "Gota, Gota, Gota, Gujarat, Ahmedabad, 380005",
  //         email: "milan@yopmail.com",
  //         phone: "917688456467",
  //         gst_no: "27AAACB3334F1Z0",
  //       },
  //       invoice_no: "INV-1746526610321",
  //       invoice_date: "2025-05-06T10:17:16.061000",
  //       invoice_data: {
  //         subscription_name: "Welcome Package",
  //         rate: 12.0,
  //         amount: 120000.0,
  //         sgst_rate: 6.0,
  //         cgst_rate: 6.0,
  //         sgst_amount: 7200.0,
  //         cgst_amount: 7200.0,
  //         total_tax_amount: 14400.0,
  //         grand_total: 134400.0,
  //       },
  //       bank_details: {
  //         company_name: "Nivzen Online Deals LLP",
  //         pan: "AATFN3023G",
  //         account_no: "025905004907",
  //         bank_name: "ICICI Bank, S.G. Highway Ahmedabad (Gujarat) India",
  //         ifsc_code: "ICIC0002895",
  //         swift_code: "ICICINBBCTS",
  //       },
  //     },
  //   };

  //   setOrderData(staticData.data);
  // }, []);

  useEffect(() => {
    console.log("Updated orderData:", orderData);
  }, [orderData]);

  if (!orderData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  const getBase64ImageFromUrl = (url) => {
    // return new Promise((resolve, reject) => {
    //   const img = new Image();
    //   img.crossOrigin = "Anonymous"; // Enable cross-origin fetching
    //   img.src = url;
    //   img.onload = () => {
    //     const canvas = document.createElement("canvas");
    //     canvas.width = img.width;
    //     canvas.height = img.height;
    //     const ctx = canvas.getContext("2d");
    //     ctx.drawImage(img, 0, 0);
    //     const dataURL = canvas.toDataURL("image/png");
    //     resolve(dataURL);
    //   };
    //   img.onerror = (err) => {
    //     reject(err);
    //   };
    // });
  };
  const downloadAsPDF = () => {
    if (pdfContainerRef.current) {
      setIsDownloading(true);

      if (buttonRef.current) {
        buttonRef.current.classList.add("hide-in-pdf");
      }

      html2canvas(pdfContainerRef.current, {
        useCORS: true,
        allowTaint: false,
        scrolling: true,
        scale: 2,
        logging: true,
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");

          const pdf = new jsPDF("l", "mm", "a4");
          const imgProps = pdf.getImageProperties(imgData);
          const pdfWidth = pdf.internal.pageSize.getWidth(); 
          const pdfHeight = pdf.internal.pageSize.getHeight(); 

          const canvasAspectRatio = canvas.width / canvas.height; 
          const pdfAspectRatio = pdfWidth / pdfHeight;

          let imgWidth, imgHeight;

          if (canvasAspectRatio > pdfAspectRatio) {
            imgWidth = pdfWidth; 
            imgHeight = (canvas.height * pdfWidth) / canvas.width;
          } else {
            imgHeight = pdfHeight; 
            imgWidth = (canvas.width * pdfHeight) / canvas.height; 
          }

          const xOffset = (pdfWidth - imgWidth) / 2;
          const yOffset = (pdfHeight - imgHeight) / 2;
          pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
          pdf.save(`Invoice-${orderData.invoice_no}.pdf`);

          if (buttonRef.current) {
            buttonRef.current.classList.remove("hide-in-pdf");
          }
          setIsDownloading(false);
        })
        .catch((error) => {
          if (buttonRef.current) {
            buttonRef.current.classList.remove("hide-in-pdf");
          }
          setIsDownloading(false);
        });
    } else {
      console.error("PDF container reference is not defined.");
    }
  };
  const columns = [
    {
      title: "Sr.",
      dataIndex: "sr",
      width: "90px",
      align: "center",
    },
    {
      title: "Subscription name",
      dataIndex: "subscription_name",
      align: "center",
    },
    {
      title: "GST",
      dataIndex: "rate",
      align: "right",
      render: (text) => (
        <>{`${text?.toLocaleString("en-IN", {
          maximumFractionDigits: 0,
        })} %`}</>
      ),
    },
    // {
    //   title: "Discount",
    //   dataIndex: "discount",
    //   align: "right",
    //   render: (text) => <>{`${text} %`}</>,
    // },
    {
      title: "Amount",
      dataIndex: "amount",
      align: "right",
      render: (text) => (
        <>{`₹ ${text?.toLocaleString("en-IN", {
          maximumFractionDigits: 0,
        })}`}</>
      ),
    },
    // {
    //   title: "Total",
    //   dataIndex: "total_tax_amount",
    //   align: "right",
    //   render: (text) => (
    //     <>{`₹ ${text?.toLocaleString("en-IN", {
    //       maximumFractionDigits: 0,
    //     })}`}</>
    //   ),
    // },
  ];

  const data = [
    {
      sr: 1,
      subscription_name: orderData.invoice_data.subscription_name,
      rate: orderData.invoice_data.rate,
      // discount: orderData.invoice_data.discount,
      amount: orderData.invoice_data.amount,
      total_tax_amount: orderData.invoice_data.total_tax_amount,
    },
  ];

  console.log("datax", data);

  return (
    <div className="invoice-container">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Subscription Invoice</h3>
          </div>
          <Space>
            <ButtonField
              className="BlueShadowBtn"
              type="primary"
              icon={<DownloadOutlined />}
              label={isDownloading ? "Downloading..." : "Download PDF"}
              onClick={downloadAsPDF}
              ref={buttonRef}
            >
              Download
            </ButtonField>
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5" ref={pdfContainerRef}>
        <div className="PR-body">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <img src={newLogo} alt="Default Company Logo" />

            <div>
              <h3>TAX INVOICE</h3>
              <table>
                <tr>
                  <th>
                    <b>Invoice No:</b>
                  </th>
                  <td>
                    <b>{orderData.invoice_no}</b>
                  </td>
                </tr>
                <tr>
                  <th>
                    <b>Invoice Date : </b>
                  </th>
                  <td>
                    <b>
                      {new Date(orderData.invoice_date).toLocaleString(
                        "en-IN",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        }
                      )}
                    </b>
                  </td>
                </tr>

                {/* <tr>
                <th><b>Total Amount:</b></th>
                <td><b>₹ {orderData.invoice_data.total_tax_amount}</b></td>
              </tr> */}
              </table>
            </div>
          </div>
          <div className="invofooter po1"></div>
          <div className="order-header">
            <div className="headdtl">
              <h3>From</h3>
              <table className="table-style" border="true">
                <tbody>
                  {/* <tr>
                    <td>From</td>
                    <td className="table-style-head"></td>
                  </tr> */}
                  <tr>
                    <td>Name:</td>
                    <td className="table-style-head">{orderData.from.name}</td>
                  </tr>
                  <tr>
                    <td>Mobile:</td>
                    <td className="table-style-head">{orderData.from.phone}</td>
                  </tr>
                  <tr>
                    <td>Email:</td>
                    <td className="table-style-head">{orderData.from.email}</td>
                  </tr>
                  <tr>
                    <td>Address:</td>
                    <td className="table-style-head">{orderData.to.address}</td>
                  </tr>
                  <tr>
                    <td>GSTN:</td>
                    <td className="table-style-head">
                      {orderData.from.gst_no}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="headdtl">
              <h3>Bill To</h3>
              <table className="table-style" border="true">
                <tbody>
                  <tr>
                    <td>Name:</td>
                    <td className="table-style-head">{orderData.to.name}</td>
                  </tr>
                  <tr>
                    <td>Mobile:</td>
                    <td className="table-style-head">{orderData.to.phone}</td>
                  </tr>
                  <tr>
                    <td>Email:</td>
                    <td className="table-style-head">{orderData.to.email}</td>
                  </tr>
                  <tr>
                    <td>Address:</td>
                    <td className="table-style-head">{orderData.to.address}</td>
                  </tr>
                  <tr>
                    <td>GSTN:</td>
                    <td className="table-style-head">{orderData.to.gst_no}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {/* 
          <Table
            className="poordertbl"
            columns={columns}
            dataSource={data}
            pagination={false}
          /> */}

          <Table
            className="poordertbl"
            columns={columns}
            dataSource={data}
            pagination={false}
          />
          <div className="invofooter po1">
            <table>
              {/* <tr>
                <th>Sub Total:</th>
                <td>
                  <b>
                    ₹{" "}
                    {orderData?.invoice_data?.amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}
                  </b>
                </td>
              </tr> */}
              <tr>
                <th>
                  CGST <strong>({orderData?.invoice_data?.cgst_rate} %)</strong>
                  :
                </th>
                <td>
                  ₹{" "}
                  {orderData?.invoice_data?.cgst_amount?.toLocaleString(
                    // "en-IN",
                    // {
                    //   maximumFractionDigits: 0,
                    // }
                  )}
                </td>
              </tr>
              <tr>
                <th>
                  SGST <strong>({orderData?.invoice_data?.sgst_rate} %)</strong>{" "}
                  :
                </th>
                <td>
                  ₹{" "}
                  {orderData?.invoice_data?.sgst_amount?.toLocaleString(
                    // "en-IN",
                    // {
                    //   maximumFractionDigits: 0,
                    // }
                  )}
                </td>
              </tr>
              <tr>
                <th className="ttlbg">
                  <b>Total:</b>
                </th>
                <td className="ttlbg">
                  <b>
                    ₹{" "}
                    {orderData?.invoice_data?.grand_total?.toLocaleString(
                      // "en-IN",
                      // {
                      //   maximumFractionDigits: 0,
                      // }
                    )}
                  </b>
                </td>
              </tr>
            </table>
          </div>
          <div className="hltxt">
            AMOUNT IN WORDS:{" "}
            <b>
              {numberToWords(
                orderData?.invoice_data?.grand_total?.toFixed(0)
              )}
            </b>
          </div>
          <div className="orderpdtl ftrsigntbl rightalign">
            <p className="authsign">
              <br />
              Authorised Signatory
            </p>
          </div>

          <div className="headdtl" style={{ width: "fit-content" }}>
            <h3>Bank Details</h3>
            <table className="table-style" border="true">
              <tbody>
                <tr>
                  <td>
                    <b>Company:</b>
                  </td>
                  <td className="table-style-head">
                    {orderData?.bank_details?.company_name}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>PAN:</b>
                  </td>
                  <td className="table-style-head">{orderData.from.phone}</td>
                </tr>
                <tr>
                  <td>
                    <b>Account No.:</b>
                  </td>
                  <td className="table-style-head">
                    {orderData?.bank_details?.account_no}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Bank:</b>
                  </td>
                  <td className="table-style-head">
                    {orderData?.bank_details?.bank_name}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>IFSC code:</b>
                  </td>
                  <td className="table-style-head">
                    {orderData?.bank_details?.ifsc_code}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>SWIFT code:</b>
                  </td>
                  <td className="table-style-head">
                    {orderData?.bank_details?.swift_code}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

Commercialinvoicepdf.propTypes = {
  id: PropTypes.number,
  vendorId: PropTypes.number,
};

export default Commercialinvoicepdf;
